import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function EditLocationIcon(props: IconProps) {
    return <Icon {...props} iconKey={"edit_location"}/>
}
